import {
    ADD_FAVOURITE_PORTFOLIO_SUCCESS,
    FETCH_ALL_PORTFOLIO_SUCCESS,
    FETCH_PORTFOLIO_SUCCESS,
    FILTER_PORTFOLIO,
    GET_ALL_PORTFOLIO,
    GET_UNSELECTED_ALL_PORTFOLIO,
    HANDLE_PORTFOLIO_REQUEST_CLOSE,
    HIDE_PORTFOLIO_LOADER,
    SHOW_PORTFOLIO_LOADER,
    ON_ADD_PORTFOLIO,
    ON_EDIT_PORTFOLIO,
    ON_ALL_PORTFOLIO_SELECT,
    ON_PORTFOLIO_CLOSE,
    ON_PORTFOLIO_SELECT,
    ON_DELETE_PORTFOLIO_SUCCESS,
    ON_FILTER_SELECTED_PORTFOLIO,
    ON_FILTER_PORTFOLIO_OPTION_SELECT,
    ON_SAVE_PORTFOLIO_SUCCESS,
    ON_TOGGLE_PORTFOLIO_DRAWER,
    SHOW_PORTFOLIO_MESSAGE,
    UPDATE_SEARCH_PORTFOLIO,
    CLEAR_SESSION,
    ON_PORTFOLIO_DASHBOARD_SUCCESS,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const ALL_FILTER = 'All portfolios';
export const STARRED_FILTER = 'Starred portfolios';
export const SUCCESSFUL_UPDATE = 'Portfolio Updated Successfully';
export const SUCCESSFUL_FILTER = 'Portfolio Filtered Successfully';
export const SUCCESSFUL_DELETE = 'Portfolio Deleted Successfully';
export const REMOVED_AS_STAR = 'Portfolio removed as star';
export const MARKED_AS_STAR = 'Portfolio marked as star';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No portfolios found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: ALL_FILTER,
    allPortfolio: [],
    portfolioList: [],
    selectedPortfolio: null,
    selectedPortfolios: 0,
    addPortfolioState: false,
    editPortfolioState: false,
    searchPortfolio: '',
    selectedDashboardPortfolio: null,
    portfolio: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'http://via.placeholder.com/150x150'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedPortfolio: null,
            };
        }
        case ADD_FAVOURITE_PORTFOLIO_SUCCESS: {
            const allUpdated = state.allPortfolio.map((entry) => entry?.id === action?.payload?.id ? {
                ...entry,
                starred: !action?.payload?.starred
            } : entry);
            let listUpdated = {};
            switch (state.filterOption) {
                case ALL_FILTER: {
                    listUpdated = allUpdated;
                    break;
                }
                case STARRED_FILTER: {
                    listUpdated = allUpdated.filter((entry) => entry.starred);
                    break;
                }
            }
            return {
                ...state,
                alertMessage: action.payload.starred ? REMOVED_AS_STAR : MARKED_AS_STAR,
                showMessage: true,
                portfolioList: listUpdated,
                allPortfolio: allUpdated,
            };
        }
        case ON_PORTFOLIO_DASHBOARD_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedDashboardPortfolio: action.payload,
            };
        }
        case FETCH_PORTFOLIO_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedPortfolio: action.payload,
                addPortfolioState: false,
                editPortfolioState: false,
            };
        }
        case FETCH_ALL_PORTFOLIO_SUCCESS: {
            return {
                ...state,
                loader: false,
                allPortfolio: action.payload,
                portfolioList: action.payload,
                selectedSectionId: 1,
                searchEmp: '',
                filterOption: ALL_FILTER,
                addPortfolioState: false,
                editPortfolioState: false,
            };
        }
        case SHOW_PORTFOLIO_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_PORTFOLIO_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedPortfolios = 0;
            const portfolioList = state.portfolioList.map(portfolio => {
                if (portfolio.selected) {
                    selectedPortfolios++;
                }
                if (portfolio.id === action.payload.id) {
                    if (portfolio.selected) {
                        selectedPortfolios++;
                    }
                    return action.payload;
                } else {
                    return portfolio;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedPortfolios: selectedPortfolios,
                portfolioList: portfolioList
            };
        }
        case ON_ADD_PORTFOLIO: {
            return {
                ...state,
                addPortfolioState: true,
                editPortfolioState: false,
            };
        }
        case ON_EDIT_PORTFOLIO: {
            return {
                ...state,
                selectedPortfolio: action.payload,
                editPortfolioState: true,
                addPortfolioState: false,
            };
        }
        case ON_PORTFOLIO_CLOSE: {
            return {
                ...state,
                addPortfolioState: false,
                editPortfolioState: false,
            };
        }
        case ON_FILTER_PORTFOLIO_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let portfolioList = [];
            switch (action.payload.name) {
                case ALL_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    portfolioList = state.allPortfolio;
                    break;
                }
                case STARRED_FILTER: {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    portfolioList = state.allPortfolio.filter((portfolio) => portfolio.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, portfolioList, drawerState: false
            };
        }
        case ON_SAVE_PORTFOLIO_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_UPDATE,
                showMessage: true,
                portfolioList: addOrUpdateEntry(state.portfolioList, action.payload),
                allPortfolio: addOrUpdateEntry(state.allPortfolio, action.payload),
                loader: false,
            };
        }
        // called after a delete from the db operation to keep the current state up to date
        case ON_DELETE_PORTFOLIO_SUCCESS: {
            return {
                ...state,
                alertMessage: SUCCESSFUL_DELETE,
                showMessage: true,
                allPortfolio: state.allPortfolio.filter((portfolio) => portfolio.id !== action.payload),
                portfolioList: state.allPortfolio.filter((portfolio) => portfolio.id !== action.payload),
                selectedPortfolio: null,
            };
        }
        case ON_FILTER_SELECTED_PORTFOLIO: {
            const portfolios = state.allPortfolio.filter((portfolio) => !portfolio.selected);
            return {
                ...state,
                alertMessage: SUCCESSFUL_FILTER,
                showMessage: true,
                portfolioList: portfolios,
                selectedPortfolios: 0
            };
        }
        case FILTER_PORTFOLIO: {
            const { filterOption } = state;
            let portfolioList = [];
            if (action.payload === '') {
                portfolioList = state.allPortfolio;
            } else {
                const filterPortfolio = state.allPortfolio.filter((portfolio) =>
                    portfolio.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === ALL_FILTER) {
                    portfolioList = filterPortfolio;
                } else if (filterOption === STARRED_FILTER) {
                    portfolioList = filterPortfolio.filter((portfolio) => portfolio.starred);
                }
            }
            return { ...state, portfolioList: portfolioList };
        }
        case GET_ALL_PORTFOLIO: {
            let portfolioList = state.allPortfolio.map((portfolio) => portfolio ? {
                ...portfolio,
                selected: true
            } : portfolio);
            return {
                ...state,
                selectedPortfolios: portfolioList.length,
                allPortfolio: portfolioList,
                portfolioList: portfolioList
            };
        }
        case GET_UNSELECTED_ALL_PORTFOLIO: {
            let portfolioList = state.allPortfolio.map((portfolio) => portfolio ? {
                ...portfolio,
                selected: false
            } : portfolio);
            return {
                ...state,
                selectedPortfolios: 0,
                allPortfolio: portfolioList,
                portfolioList: portfolioList
            };
        }
        case ON_ALL_PORTFOLIO_SELECT: {
            const selectAll = state.selectedPortfolios < state.portfolioList.length;
            let selectedPortfolios = 0;
            let portfolioList = [];
            if (selectAll) {
                portfolioList = state.allPortfolio.map((portfolio) => portfolio ? {
                    ...portfolio,
                    selected: true
                } : portfolio);
                selectedPortfolios = portfolioList.length;
            } else {
                portfolioList = state.allPortfolio.map((portfolio) => portfolio ? {
                    ...portfolio,
                    selected: true
                } : portfolio);
                selectedPortfolios = 0;
            }
            return {
                ...state,
                selectedPortfolios: selectedPortfolios,
                allPortfolio: portfolioList,
                portfolioList: portfolioList
            };
        }
        case UPDATE_SEARCH_PORTFOLIO: {
            return { ...state, searchPortfolio: action.payload };
        }
        case HANDLE_PORTFOLIO_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_PORTFOLIO_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_PORTFOLIO_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_PORTFOLIO_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/portfolio.js